export default __webpack_public_path__ + "static/media/Skup Pula (14).aaaba290.JPG";